import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=7529d1ae&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7529d1ae')) {
      api.createRecord('7529d1ae', component.options)
    } else {
      api.reload('7529d1ae', component.options)
    }
    module.hot.accept("./notfound.vue?vue&type=template&id=7529d1ae&lang=pug&", function () {
      api.rerender('7529d1ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notfound.vue"
export default component.exports